import {
  Injectable,
} from '@angular/core';
import {
  OrderStore,
} from '@des/store/order';
import {
  Store,
} from '@ngrx/store';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  retrieveCurrentOrder,
  retrieveOrderCreationPointOfSaleCountryCode,
  retrieveOrderCreationPointOfSaleId,
  retrieveOrderHoursSinceCreation,
  retrieveOrderServicingPointOfSaleCountryCode,
  retrieveOrderServicingPointOfSaleId,
} from './fact-factories';
import {
  OrderFacts,
} from './order.facts';

@Injectable()
export class OrderFactsService extends FactsService<OrderFacts> {
  public facts = {
    order: this.store.pipe(retrieveCurrentOrder()),
    orderCreationPointOfSaleId: this.store.pipe(retrieveOrderCreationPointOfSaleId()),
    orderServicingPointOfSaleId: this.store.pipe(retrieveOrderServicingPointOfSaleId()),
    orderCreationPointOfSaleCountryCode: this.store.pipe(retrieveOrderCreationPointOfSaleCountryCode()),
    orderServicingPointOfSaleCountryCode: this.store.pipe(retrieveOrderServicingPointOfSaleCountryCode()),
    orderHoursSinceCreation: this.store.pipe(retrieveOrderHoursSinceCreation())
  };

  constructor(rulesEngine: RulesEngineRunnerService, private readonly store: Store<OrderStore>) {
    super(rulesEngine);
  }
}
